import { useState, useEffect } from "react";
import { C } from "../constants";

export default function MobileBanner() {
  const [dismissed, setDismissed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return null; // Mobile now supported

  return (
    <div style={{
      position:"fixed", top:0, left:0, right:0, bottom:0,
      backgroundColor:C.bg, zIndex:9999,
      display:"flex", flexDirection:"column",
      alignItems:"center", justifyContent:"center",
      padding:"2rem", textAlign:"center",
      fontFamily:"'DM Sans',sans-serif",
    }}>
      <div style={{ fontSize:"2.2rem", marginBottom:"0.5rem" }}>💘</div>
      <h1 style={{ fontFamily:"'Playfair Display',serif", fontSize:"1.6rem", color:C.text, margin:"0 0 6px" }}>
        resu<span style={{ color:C.accent }}>match</span>.ai
      </h1>
      <p style={{ fontSize:"0.75rem", color:C.accent, fontFamily:"'Space Mono',monospace", letterSpacing:"0.05em", margin:"0 0 2rem", textTransform:"uppercase" }}>
        The dating app for your career
      </p>
      <div style={{
        background:"#fff", borderRadius:16, padding:"1.5rem", maxWidth:320,
        boxShadow:"0 4px 24px rgba(0,0,0,0.08)", marginBottom:"1.5rem",
        border:`1px solid ${C.border}`,
      }}>
        <div style={{ fontSize:"2rem", marginBottom:"0.75rem" }}>🖥️</div>
        <p style={{ fontSize:"1rem", color:C.text, fontWeight:700, margin:"0 0 8px" }}>
          Best on desktop
        </p>
        <p style={{ fontSize:"0.875rem", color:C.sub, lineHeight:1.6, margin:0 }}>
          Resumatch is designed for a full-screen experience. Open it on your laptop or computer to get the most out of your job search.
        </p>
      </div>
      <button
        onClick={() => setDismissed(true)}
        style={{
          background:"none", border:"none", color:C.muted,
          fontSize:"0.8rem", cursor:"pointer", textDecoration:"underline",
          padding:"0.5rem", fontFamily:"'DM Sans',sans-serif",
        }}>
        Continue anyway
      </button>
    </div>
  );
}
